import React from 'react';
import { motion } from 'framer-motion';
import { FaPhoneAlt, FaCheckCircle, FaStar } from 'react-icons/fa';
import Classes from './Hero.module.css';
import QuoteForm from '../../../../GlobalComp/QuoteForm/QuoteForm';
import { SITE } from '../../../../../data/siteConfig';
import { Helmet } from 'react-helmet-async';
import { heroPreload, srcSetFor } from '../../../../../data/photos';

const points = [
    'Licensed & insured Florida general contractor',
    'Upfront pricing: the quote is the price',
    'Kitchens, baths, repairs & full remodels',
];

const fadeUp = (delay) => ({
    initial: { opacity: 0, y: 24 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
});

export default function Hero() {
    return (
        <section className={Classes.hero}>
            <Helmet link={[heroPreload('/assets/images/1.webp')]} />
            <img
                src="/assets/images/1.webp"
                srcSet={srcSetFor('/assets/images/1.webp')}
                sizes="100vw"
                alt=""
                aria-hidden="true"
                className={Classes.bg}
                fetchpriority="high"
                decoding="async"
            />
            <div className={Classes.overlay} />

            <div className={`container ${Classes.inner}`}>
                <div className={Classes.copy}>
                    <motion.a {...fadeUp(0.05)} href="#reviews" className={Classes.badge}>
                        <span className={Classes.badgeStars} role="img" aria-label="5 out of 5 stars">
                            {[...Array(5)].map((_, i) => <FaStar key={i} />)}
                        </span>
                        <span className={Classes.badgeScore}>{SITE.googleRating.value}</span>
                        <span className={Classes.badgeDivider} aria-hidden="true" />
                        <span className={Classes.badgeText}>Top Rated in {SITE.region}</span>
                    </motion.a>

                    <motion.h1 {...fadeUp(0.12)}>
                        South Florida’s <br className={Classes.br} />Top-Rated General Contractor
                    </motion.h1>

                    <motion.p {...fadeUp(0.2)} className={Classes.lead}>
                        20+ years of remodels, repairs and renovations across {SITE.region}, done right the first time.
                    </motion.p>

                    <motion.ul {...fadeUp(0.28)} className={Classes.points}>
                        {points.map((p) => <li key={p}><FaCheckCircle /> {p}</li>)}
                    </motion.ul>

                    <motion.div {...fadeUp(0.36)} className={Classes.buttons}>
                        <a href={SITE.bookingUrl} target="_blank" rel="noopener noreferrer" className="btn btn-light">
                            Book an Appointment
                        </a>
                        <a href={`tel:${SITE.phoneE164}`} className="btn btn-outline-light">
                            <FaPhoneAlt /> {SITE.phone}
                        </a>
                    </motion.div>
                </div>

                {/* Not faded in: a translucent parent stops the card's backdrop blur
                    from rendering, so it flashes see-through on load. */}
                <div className={Classes.formWrap} id="quote">
                    <QuoteForm />
                </div>
            </div>
        </section>
    );
}
